import { testTranslateService as featureTestTranslateService } from '@plugins/client/feature-check';
import {
  KeyAndLoader,
  registerPluginTranslation,
} from '@plugins/client/translate/loaders';
import {
  mergeTranslateTargetsToSource,
  prepareTestTranslateService,
  TranslateService,
} from '@plugins/client/translate/services';

import { commonLoader } from './app-translation-loader';

const FRONTOFFICE_TRANSLATION_KEY = 'id-card-wsw-frontoffice',
  BACKOFFICE_TRANSLATION_KEY = 'id-card-wsw-backoffice';

export const frontofficeLoader = (lang: string) =>
    import(`../../assets/i18n/frontend/wsw/${lang}.json`),
  backofficeLoader = (lang: string) => [
    import(`../../assets/i18n/backoffice/${lang}.json`),
    import(`../../assets/i18n/backoffice/wsw/${lang}.json`),
  ];

const frontofficeSource: KeyAndLoader = {
  loader: frontofficeLoader,
  key: FRONTOFFICE_TRANSLATION_KEY,
};

const backofficeSource: KeyAndLoader = {
  loader: backofficeLoader,
  key: BACKOFFICE_TRANSLATION_KEY,
};

export const loadFrontofficeTranslations =
  registerPluginTranslation(frontofficeSource);
export const loadBackofficeTranslations =
  registerPluginTranslation(backofficeSource);

export const wswTestTranslateService = async () => {
  return mergeTranslateTargetsToSource(
    prepareTestTranslateService({
      key: 'id-card',
      loaders: [commonLoader, frontofficeLoader, backofficeLoader],
    }),
    featureTestTranslateService(),
  );
};

export const wswTranslateProvider = async () => {
  return {
    provide: TranslateService,
    useValue: await wswTestTranslateService(),
  };
};
